import React from 'react';
import { MAIN_MOCKUP_URL } from '../data/assets';
type ProductStackProps = {
  label?: string;
  className?: string;
};
const volumes = [{
  n: '1',
  t: 'Opening the Door',
  c: 'bg-forest'
}, {
  n: '2',
  t: 'Vitality & Play',
  c: 'bg-ember-deep'
}, {
  n: '3',
  t: 'Connection & Care',
  c: 'bg-moss-deep'
}, {
  n: '4',
  t: 'Creativity & Expression',
  c: 'bg-patrol-plum'
}, {
  n: '5',
  t: 'Presence & Nature',
  c: 'bg-patrol-teal'
}, {
  n: '6',
  t: 'Workshops, Retreats & Festivals',
  c: 'bg-bark'
}];

/**
 * Imagen de producto. Si hay mockup principal (data/assets.ts) se usa ese;
 * si no, las seis portadas de volumen dibujadas con CSS.
 */
export function ProductStack({
  label = '6 volumes · 84 plans',
  className = ''
}: ProductStackProps) {
  if (MAIN_MOCKUP_URL) {
    return <img src={MAIN_MOCKUP_URL} alt="The six Vivencia Ready volumes and plan cards on a table in a sunlit dance studio" width={2048} height={1365} className={`mx-auto h-auto w-full rounded-2xl shadow-stack ring-1 ring-black/10 ${className}`} data-id="element-222" data-mp="w3q7ejvd2hrx" />;
  }
  return <div className={`relative mx-auto w-full max-w-[440px] pb-6 ${className}`} data-id="element-223" data-mp="1e1oessjm7jta">
      <ul className="grid grid-cols-3 gap-2.5 sm:gap-3" aria-label="The six Vivencia Ready volumes" data-id="element-224" data-mp="1a0kx00i0bdpf">
        {volumes.map((v, i) => <li key={v.n} className={`flex aspect-[3/4] flex-col justify-between rounded-lg p-2.5 shadow-stack ring-1 ring-black/10 sm:p-3 ${v.c} ${i % 2 === 0 ? '-rotate-2' : 'rotate-2'}`} data-id="element-225" data-mp="152jh1ofvnui6" data-mpi={i}>
            <span className="text-[8px] font-bold uppercase tracking-[1.5px] text-white/80 sm:text-[9px]" data-id="element-226" data-mp="1szgtjihc846f">
              Vivencia Ready · Vol. {v.n}
            </span>
            <span className="font-display text-[13px] leading-tight text-white sm:text-[15px]" data-id="element-227" data-mp="1nzudl1a4k9tx">
              {v.t}
            </span>
            <span className="text-[8px] font-semibold text-white/75 sm:text-[9px]" data-id="element-228" data-mp="2gp1fma8sfhjx">
              14 vivencia plans
            </span>
          </li>)}
      </ul>
      <span className="absolute bottom-0 left-1/2 z-20 -translate-x-1/2 whitespace-nowrap rounded-full bg-ember px-4 py-2 text-[12px] font-bold uppercase tracking-wide text-pine shadow-card" data-id="element-229" data-mp="2zm1tc1uqiz7i">
        {label}
      </span>
    </div>;
}